export default "__VITE_ASSET__11b69bfb__"